import React from 'react'

export const InfoCircleIcon: React.FC = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.5 12C20.5 16.4182 16.9183 20 12.5 20C8.08172 20 4.5 16.4182 4.5 12C4.5 7.58169 8.08172 3.99997 12.5 3.99997C16.9183 3.99997 20.5 7.58169 20.5 12ZM22.5 12C22.5 17.5228 18.0228 22 12.5 22C6.97715 22 2.5 17.5228 2.5 12C2.5 6.47712 6.97715 1.99997 12.5 1.99997C18.0228 1.99997 22.5 6.47712 22.5 12ZM13.5 8.87497V6.99997H11.5V8.87497H13.5ZM13.5 17V10.75H11.5V17H13.5Z"
        fill="#220C4A"
      />
    </svg>
  )
}

export default InfoCircleIcon
